import type { JobStatus } from '@uroute/shared';

/**
 * Statuses that mean the delivery itself is finished. Auto-pricing moves a
 * freshly completed job straight to a financial status (completed ->
 * invoice_draft), so driver-facing surfaces must treat the whole tail as
 * "delivered" rather than only the literal `completed` status.
 */
const DELIVERED_STATUSES: readonly JobStatus[] = [
  'completed',
  'invoice_draft',
  'invoice_sent',
  'payment_completed',
];

export function isDelivered(status: JobStatus): boolean {
  return DELIVERED_STATUSES.includes(status);
}
